export default "__VITE_ASSET__C_e$AeLv__ 100w";